import { globalConstants, invoiceConstants } from "../../constants";

const initialState = {
  invoiceData: null,
};

const InvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case invoiceConstants.INVOICE_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        invoiceData: action.data,
      };
    case invoiceConstants.INVOICE_DATA_NULL + globalConstants.SUCCESS:
      return {
        ...state,
        invoiceData: null,
      };
    default:
      return state;
  }
};

export default InvoiceReducer;
